import script from "./AeroflotBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AeroflotBanner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn,QCard,QCardSection});
